import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
  Button,
  CircularProgress,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Label from "../../../../components/Label/Label";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import RefreshIcon from "@mui/icons-material/Refresh";

const CreateChartsPanel = ({
  setCharts,
  charts,
  activeId,
  setAnchorEl,
  setActiveId,
  anchorEl,
  handleAddChart,
  setShowConfigPanel,
  setSelectedTab,
  saving,
  setSaveDialogOpen,
  disableAllFields,
  showSummaryTable,
  setShowSummaryTable,
  showViolationTable,
  setShowViolationTable,
  handleRefresh,
  saveDisabled,
}) => {
  // ---------- Handlers ----------

  const handleToggleSelect = (id) => {
    setCharts((prev) =>
      prev.map((c) => (c.id === id ? { ...c, selected: !c.selected } : c)),
    );
  };

  const handleNameChange = (id, value) => {
    setCharts((prev) =>
      prev.map((c) => (c.id === id ? { ...c, name: value } : c)),
    );
  };

  const handleDelete = () => {
    setCharts((prev) => prev.filter((c) => c.id !== activeId));
    handleMenuClose();
  };

  const handleEdit = () => {
    setCharts((prev) =>
      prev.map((c) => (c.id === activeId ? { ...c, isEditing: true } : c)),
    );
    handleMenuClose();
    setShowConfigPanel(true);
    setSelectedTab("parameter");
  };

  const handleBlur = (id) => {
    setCharts((prev) =>
      prev.map((c) => (c.id === id ? { ...c, isEditing: false } : c)),
    );
  };

  const handleMenuOpen = (e, id) => {
    setAnchorEl(e.currentTarget);
    setActiveId(id);
    setShowConfigPanel(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setActiveId(null);
  };

  // ---------- UI ----------

  const isChartValid = (chart) => {
    const ps = chart?.parameterState;

    return (
      !!ps?.product?.id &&
      !!ps?.site?.id &&
      !!ps?.unitOfOperation?.id &&
      !!ps?.parameter?.parameterId &&
      !!ps?.plotType
    );
  };

  const isSaveDisabled =
    disableAllFields || charts.some((c) => !isChartValid(c));

  return (
    <Box className="side-card-wrapper">
      {/* Header */}

      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Label text="Saved Charts" fontSize="14px" fontWeight="500" />

        <Tooltip title="Refresh to load latest changes from data" arrow>
          <IconButton size="small" onClick={handleRefresh}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Divider />

      {/* Scrollable List */}
      <Box
        sx={{
          mt: 1,

          borderRadius: 1,
          border: "1px solid #eee",
          flex: 1, // takes remaining space
          overflowY: "auto", // scroll only here
        }}
      >
        {charts.map((chart) => (
          <Box
            key={chart.id}
            display="flex"
            alignItems="center"
            px={1}
            py={0.5}
            mb={0.5} // 👈 GAP BETWEEN ITEMS
            border="1px solid #f0f0f0" // optional: box style instead of bottom border
            borderRadius={1} // optional: rounded card look
            bgcolor="#fff"
          >
            <Checkbox
              checked={chart.selected}
              size="small"
              onChange={() => handleToggleSelect(chart.id)}
            />

            <TextField
              variant="standard"
              value={chart.name}
              placeholder="Chart name"
              fullWidth
              onChange={(e) => handleNameChange(chart.id, e.target.value)}
              onBlur={() => handleBlur(chart.id)}
              // InputProps={{
              //   disableUnderline: true,
              //   readOnly: !chart.isEditing,
              // }}
            />

            <IconButton
              size="small"
              onClick={(e) => handleMenuOpen(e, chart.id)}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>

      <Box mt={2}>
        <Label text="Display Options" fontSize="14px" fontWeight="500" />

        <FormControlLabel
          control={
            <Checkbox
              checked={showSummaryTable}
              onChange={(e) => setShowSummaryTable(e.target.checked)}
              size="small"
            />
          }
          label="Show Summary Table"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={showViolationTable}
              onChange={(e) => setShowViolationTable(e.target.checked)}
              size="small"
            />
          }
          label="Show Violation Table"
        />
      </Box>
      <Tooltip
        title={
          isSaveDisabled
            ? "Complete configuration and generate all charts to enable saving"
            : ""
        }
        arrow
      >
        {/* {firstChartIdToShowSave === chartId && ( */}
        <span>
          {" "}
          <Button
            fullWidth
            // size="small"
            variant="contained"
            // startIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
            onClick={() => setSaveDialogOpen(true)}
            // sx={{ textTransform: "none", fontSize: "12px" }}
            // disabled={disableAllFields || saving}
            disabled={isSaveDisabled || saveDisabled}
          >
            {/* {saving ? "Saving..." : "Save"} */}
            Save
          </Button>
        </span>
        {/* )} */}
      </Tooltip>
      {/* Create Button */}
      <Button
        variant="outlined"
        fullWidth
        sx={{ mt: 1 }}
        onClick={handleAddChart}
        startIcon={<AddIcon />}
      >
        Create New Chart
      </Button>

      {/* Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </Box>
  );
};

export default CreateChartsPanel;
